import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Register from "@/pages/Register";
import PlayerLogin from "@/pages/PlayerLogin";
import PlayerDashboard from "@/pages/PlayerDashboard";
import PublicPlayer from "@/pages/PublicPlayer";
import SelectedPlayers from "@/pages/SelectedPlayers";
import HplPlayers from "@/pages/HplPlayers";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPlayers from "@/pages/admin/AdminPlayers";
import AdminTrials from "@/pages/admin/AdminTrials";
import AdminAuction from "@/pages/admin/AdminAuction";
import AdminTeams from "@/pages/admin/AdminTeams";
import AdminMatches from "@/pages/admin/AdminMatches";
import AdminSponsors from "@/pages/admin/AdminSponsors";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminSelectedPlayers from "@/pages/admin/AdminSelectedPlayers";
import AdminTrialSlotBookings from "@/pages/admin/AdminTrialSlotBookings";
import AdminHplRegistrations from "@/pages/admin/AdminHplRegistrations";

const RequireAdmin = ({ children }) => {
  const t = localStorage.getItem("ndpl_admin_token");
  return t ? children : <Navigate to="/admin/login" replace />;
};
const RequirePlayer = ({ children }) => {
  const t = localStorage.getItem("ndpl_player_token");
  return t ? children : <Navigate to="/player/login" replace />;
};

export default function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-right" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/player/login" element={<PlayerLogin />} />
          <Route path="/player/dashboard" element={<RequirePlayer><PlayerDashboard /></RequirePlayer>} />
          <Route path="/p/:slug" element={<PublicPlayer />} />
          <Route path="/selected-players" element={<SelectedPlayers />} />
          <Route path="/hpl-players" element={<HplPlayers />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
            <Route index element={<AdminDashboard />} />
            <Route path="players" element={<AdminPlayers />} />
            <Route path="trials" element={<AdminTrials />} />
            <Route path="auction" element={<AdminAuction />} />
            <Route path="teams" element={<AdminTeams />} />
            <Route path="matches" element={<AdminMatches />} />
            <Route path="sponsors" element={<AdminSponsors />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="notifications" element={<AdminNotifications />} />
            <Route path="selected-players" element={<AdminSelectedPlayers />} />
            <Route path="trial-slot-bookings" element={<AdminTrialSlotBookings />} />
            <Route path="hpl-registrations" element={<AdminHplRegistrations />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
